import { eventsRequest } from '../../utils/eventsRequest';
import type { OutstandingFormsResponse, OutstandingFormItem, RequiredEventForm } from '../../types';

/**
 * Maps API outstanding form item to UI RequiredEventForm.
 */
export function mapOutstandingFormItemToRequiredEventForm(item: OutstandingFormItem): RequiredEventForm {
  return {
    id: item.formId,
    formName: item.templateName,
    eventName: item.eventName,
    completed: false,
    childId: item.childId,
    childName: item.childName,
    eventId: item.eventId,
    eventUuid: item.eventUuid,
    form: item.form,
  };
}

/**
 * Fetches remaining required event forms (To Do items) for the logged-in parent.
 * Returns { hasOutstandingForms, outstandingForms, remainingCount } in response.data.
 */
const getUserOutstandingForms = async (): Promise<OutstandingFormsResponse | null> => {
  try {
    const response = await eventsRequest<OutstandingFormsResponse>('/orders/forms', 'get');

    if (response.status === 200 || response.status === 201) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.error('❌ Error fetching outstanding forms:', error);
    return null;
  }
};

export default getUserOutstandingForms;

